import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ModalAddguestComponent } from "../modal-addguest/modal-addguest.component";
import { CloudbedsService } from "@app/services/cloudbeds.service";
import { Storage } from "@ionic/storage";
import { AlertService } from "@app/shared/services/alert.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LoadingService } from "@app/shared/services/loading.service";
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { environment } from "@env/environment";
import moment from "moment";
registerLocaleData(localeEn, 'en');

@Component({
  selector: "app-modal-data-reservation",
  templateUrl: "./modal-data-reservation.component.html",
  styleUrls: ["./modal-data-reservation.component.scss"],
})
export class ModalDataReservationComponent implements OnInit {
  @Input() reservation: any = null;
  @Input() title: any;
  public roomIdx: number = 0;
  today = moment().format('LL')
  tomorrow = moment().add(1, 'day').format('LL')
  public addGuest: boolean;
  public roomManager: boolean = false;
  public environment = environment;
  multipleRoom: boolean;
  public showNext: boolean = false;
  constructor(
    private modalCtrlr: ModalController,
    private router: Router,
    private route: ActivatedRoute,
    public storage: Storage,
    private alertService: AlertService,
    private loading: LoadingService,
    private cloudbedsService: CloudbedsService
  ) {}

  async ngOnInit() {
    if (environment.demoMode){
      this.route.queryParams.subscribe(async (params) => {
        if (params.roomManager) this.roomManager = JSON.parse(params.roomManager);
        this.multipleRoom = await this.storage.get("multipleRoom");
        console.log(params);
      });
    }else{
      console.log(this.reservation);
      if (this.reservation == null)
        this.reservation = await this.storage.get("reservationData");
      if (this.reservation.assigned.length == this.roomIdx + 1)
        this.showNext = false;
      this.route.queryParams.subscribe((params) => {
        if (params.roomManager) this.roomManager = JSON.parse(params.roomManager);
        console.log(params);
      });
    }
  }

  goBack() {
    // this.modalCtrlr.dismiss();
    window.history.back();
  }

  async find() {
    console.log(this.addGuest);
    if (this.addGuest) {
      this.openAddGuesModal();
    }
    this.goBack();
    // this.cloudbedsService.findReservation("6278034245206").then(res => {
    // this.modalCtrlr.dismiss({result: true});
    // });
  }

  nextRoom() {
    this.roomIdx += 1;
    if (this.reservation.assigned.length == this.roomIdx+1) this.showNext = false;
    console.log(this.roomIdx, this.showNext)
  }
  async checkin() {
    if (environment.demoMode) {
      this.confirmCheckIn();
      await this.loading.dismiss();
      return;
    }
    await this.loading.presentLoading();
    if (this.roomIdx + 1 == this.reservation.assigned.length) {
      if (this.addGuest) {
        this.openAddGuesModal();
        await this.loading.dismiss();
      } else {
        this.confirmCheckIn();
      }
    } else {
      await this.loading.dismiss();
      this.roomIdx += 1;
      if (this.reservation.assigned.length == this.roomIdx+1) this.showNext = false;
    }
  }

  async confirmCheckIn() {
    if (environment.demoMode) {
      this.router.navigate(["welcome-checkin/success-checkin"]);
      await this.loading.dismiss();
      return;
    }
    if (!environment.nexi.simulateCheckIn) {
      this.cloudbedsService
        .checkin(this.reservation.reservationID)
        .then(async (result) => {
          this.storage.set("reservationData", this.reservation);
          this.router.navigate(["welcome-checkin/success-checkin"]);
          await this.loading.dismiss();
          // this.modalCtrlr.dismiss({result: true})
        })
        .catch(async (res) => {
          console.log(res);
          await this.loading.dismiss();
          await this.alertService.presentInfoAlert(res.error, "Error", [
            { text: "Dismiss" },
          ]);
        });
    }
    else {
      this.storage.set("reservationData", this.reservation);
      this.router.navigate(["welcome-checkin/success-checkin"]);
      await this.loading.dismiss();
    }
  }

  async openAddGuesModal() {
    const modal = await this.modalCtrlr.create({
      cssClass: "ad-alert-modal",
      component: ModalAddguestComponent,
      componentProps: {
        title: "",
        reservationId: environment.demoMode ? "4512345388747" : this.reservation.reservationID,
        buttons: [
          {
            title: "Dismiss",
            value: "cancel",
          },
        ],
      },
    });
    await modal.present().then((result) => {});
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log(data);
    // this.confirmCheckIn();
    if (data && data.result) {
      this.confirmCheckIn();
    } else {
      await this.alertService.presentInfoAlert(data.message, "Error", [
        { text: "Dismiss" },
      ]);
    }
  }

  upgrade() {
    this.router.navigate(["/welcome-checkin/upgrade-room"]);
  }
}
